export default __webpack_public_path__ + "static/media/uisge.84869aa1.mp3";